import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../../../../common/FormBase';
import Form from './Form';
import { MakeFields } from './validation/fields';
import { makeInitialState } from '../../../../../helpers/FormHelper';
import { schema } from './validation/schema';

const AuthorizeThird = ({ ...props }) => {
  const { mobile, issueForm, motiveId, typeId } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [validLength] = useState(12);
  const [valid, setValid] = useState(false);
  const [showForm, setShowForm] = useState(true);

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        pre={!showForm}
        issueForm={issueForm}
        mobile={mobile}
        title=""
        formName="AuthorizeThird"
        motiveId={motiveId}
        typeId={typeId}
        validLength={validLength}
        onState={onState}
        data={data}
        makeInitialState={makeInitialState}
        fields={MakeFields()}
        schema={schema}
        onValid={handleValid}
        form={
          <Form
            motiveId={motiveId}
            mobile={mobile}
            state={state}
            onData={handleData}
            valid={valid}
            fields={MakeFields()}
            setShowForm={setShowForm}
          />
        }
      />
    </React.Fragment>
  );
};

AuthorizeThird.propTypes = {
  mobile: PropTypes.bool,
  issueForm: PropTypes.bool,
  motiveId: PropTypes.string,
  typeId: PropTypes.string,
};

export default AuthorizeThird;
